import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { ReactComponent as IconLauncher } from 'asserts/icons/ic_Launcher.svg';
import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import { Table } from 'antd';
import InstallList from 'components/list/InstallList';
import DefaultButton from 'components/button/DefaultButton';
import Viewer from 'components/layer/Viewer';
import { computerSpecData, computerSpecDataColumns } from 'consts/download';

const DownLoad = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openViewer = () => {
    setIsViewerOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
    document.body.style.overflow = 'visible';
  };

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Wrapper>
        <img src="/images/download_bg.png" alt="다운로드 배경이미지" loading="lazy" />
        <div>
          <ContentsWrapper>
            <IconLauncher />
            <h2>
              엑스바디 프로그램을
              <br />
              다운로드 받으실 수 있습니다.
            </h2>
            <a href="https://cdn.exbody.metafamily.world/setup/exbody_setup.exe" download>
              <DefaultButton text="다운로드" />
            </a>
            <VersionWrapper>
              <p>버전 : 1.21</p>
              <p>업데이트 : 2024-04-16</p>
            </VersionWrapper>
          </ContentsWrapper>
        </div>
      </Wrapper>
      <ListWrapper>
        <InstallList openViewer={openViewer} HeaderTitle="프로그램 설치 방법" />
      </ListWrapper>
      <TableWrapper>
        <h3>프로그램 설치 사양 안내</h3>
        <Table
          columns={computerSpecDataColumns}
          dataSource={computerSpecData}
          pagination={false}
          bordered
        />
      </TableWrapper>
      {isViewerOpen && (
        <Viewer
          onClose={closeViewer}
          selectedItem="/images/exbody_Install.mp4"
          selectedTitle="프로그램 설치 방법"
          type={'video'}
        />
      )}
    </>
  );
};

export default DownLoad;

const Wrapper = styled.div`
  position: relative;

  img {
    width: 100%;
    height: calc(100vh - 112px);
    object-fit: cover;
  }

  & > div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${color.opacityBlack04};
    backdrop-filter: blur(6px);
  }
`;

const gradient = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const ContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  h2 {
    ${font.d1_bold};
    text-align: center;
    background: ${color.gradientType1};
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: ${gradient} 3s linear infinite;
    background-size: 200% 100%;
  }

  button.ant-btn.ant-btn-default {
    width: 240px;
    height: 48px;
    border-radius: 24px;
    border: none;
    background: ${color.gradientType1};
    color: ${color.black2} !important;
    ${font.h3_medium};
  }
`;

const VersionWrapper = styled.div`
  p {
    text-align: center;
    color: ${color.opacityWhite07};
    ${font.caption1_regular};
  }
`;

const ListWrapper = styled.div`
  h2 {
    color: ${color.navyLight};
    ${font.d1_bold};
  }
  background: ${color.blue50};
`;

const TableWrapper = styled.div`
  width: 890px;
  margin: 0 auto;

  h3 {
    padding: 128px 0 48px;
    ${font.h2_bold};
    color: ${color.navyLight};
    text-align: center;
  }

  table,
  thead th.ant-table-cell {
    text-align: center;
    color: ${color.gray600};
    font-size: 14px;
    line-height: 17px;
  }

  tbody td {
    color: ${color.black2};
  }
`;
